'use client';

import { ActionButtonWithDescription } from '@/shared/components/action-button-with-description';
import { ExternalPlayIcon } from '@/shared/components/primitives/svg/external-play-icon';
import { useTranslations } from 'next-intl';
import { cn } from '@/shared/utils/cn';
import { GameData } from '@/features/games/shared/types/game-data';
import { replacePlaceholders } from '@/features/games/internal/helpers/replace-placeholder-for-online-game-inks';
import { useIsWTGamesApp } from '@/features/games-app-bridge/shared/hooks/use-is-wt-games-app';
import { getIpcClient } from '@/features/games-app/shared/client/ipc-client';
import { ResponseLaunchProduct } from '@/features/games-app/shared/types/ipc.types';

export const PlayThirdPartyGameButton = ({
  gameData,
  className,
}: {
  gameData: GameData;
  className?: string;
}) => {
  const t = useTranslations('GamePage');
  const isGamesApp = useIsWTGamesApp();

  const title = (
    <span className='flex items-center gap-1'>
      <ExternalPlayIcon /> {t('play')}
    </span>
  );

  const handleOpenLink = async (): Promise<void> => {
    if (!gameData.linkUrl) {
      return;
    }
    const gameUrl = replacePlaceholders(gameData.linkUrl);
    if (isGamesApp) {
      const ipcClient = getIpcClient();
      await ipcClient.send<ResponseLaunchProduct>({
        name: 'environment',
        action: 'launchexternalbrowser',
        body: { externalUrl: gameUrl },
      });
      return;
    }
    window.open(replacePlaceholders(gameData.linkUrl!), '_blank');
    return;
  };

  return (
    <>
      <ActionButtonWithDescription
        title={<span className='text-lg'>{title}</span>}
        description={t('stableConnectionRequired')}
        variant='primary'
        onClick={handleOpenLink}
        className={cn('min-h-20', className)}
      />
    </>
  );
};
